var path = 'src/app/forms/fields/date-field.html';
var html = "<input date-validator frm-date-picker frm-model frm-required ng-required=required() ng-model=model min-date=minDate max-date=maxDate type=text class=form-control date-picker-min-date={{minDate}} date-picker-max-date={{maxDate}} date-picker-default-date={{defaultDate}} placeholder=DD/MM/YYYY /> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/date-field.html
 ** module id = 263
 ** module chunks = 0
 **/